export const notificationSMSCalling = "@/notification/@SMSCalling";
export const notificationSMSSuccess = "@/notification/@SMSSuccess";
export const notificationSMSFailure = "@/notification/@SMSFailure";
